import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ChequeLayoutDto,
  ChequeLayoutListDto,
  ChequeLayoutFilterDto,
  CreateChequeLayoutRequest,
  UpdateChequeLayoutRequest,
} from '@/types/chequeLayout.types';

export const chequeLayoutApi = {
  /** GET /api/v1/cheque-layouts — paginated list with optional filter */
  getList: (filter?: ChequeLayoutFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<ChequeLayoutListDto>>>('/cheque-layouts', {
      params: filter,
    }),

  /** GET /api/v1/cheque-layouts/{id} — full cheque layout record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<ChequeLayoutDto>>(`/cheque-layouts/${id}`),

  /** POST /api/v1/cheque-layouts — create a new layout */
  create: (data: CreateChequeLayoutRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/cheque-layouts', data),

  /** PUT /api/v1/cheque-layouts/{id} — update layout */
  update: (id: string, data: UpdateChequeLayoutRequest) =>
    apiClient.put<ApiResponse<object>>(`/cheque-layouts/${id}`, data),

  /** DELETE /api/v1/cheque-layouts/{id} — soft-delete */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/cheque-layouts/${id}`),
};
